import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import NkTable from "../nktable";
import moment from "moment";
import { getCreationHistory } from "../../../service/profile-ras-service";
import Loading from "../../loader/loader.js";

const RakProfileCreateHistory = ({ allUsersObject, userId }) => {
  const [dataLoading, setDataLoading] = useState(true);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const columns = [
    {
      dataField: "status",
      text: "Status",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      style: { minWidth: "150px", textAlign: "Left" },
      formatter: (cell, row) => {
        return cell && cell !== ""
          ? cell === "0000-00-00 00:00:00"
            ? "N/A"
            : moment(cell).format("YYYY-MM-DD HH:mm")
          : "N/A";
      },
    },
    {
      dataField: "reason",
      text: "Reason",
      sort: false,
      style: { minWidth: "200px", textAlign: "left" },
    },
  ];

  useEffect(() => {
    if (allUsersObject.emiratesId) {
      getProfileHistoryDetails(allUsersObject.emiratesId);
    }
  }, [allUsersObject.emiratesId]);

  const [historyDetails, setHistoryDetails] = useState([]);

  const getProfileHistoryDetails = (eid) => {
    getCreationHistory(eid)
      .then((res) => {
        console.log(res);
        setHistoryDetails(res && res.data);
      })
      .catch((err) => {
        console.log(err);
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setHistoryDetails([]);
      }).finally(() => {
        setDataLoading(false);
      });
  };

  return (
    <>
      <Card>
        <CardBody
          style={{
            paddingTop: 20,
            paddingBottom: 20,
          }}
        >
          <CardTitle
            tag="h1"
            className="user-verification-header"
          >
            RAK Profile Creation History
          </CardTitle>
          {dataLoading ? (
            <div style={{ textAlign: "center" }}>
              <Loading />
            </div>
          ) : (
              <NkTable
                data={historyDetails}
                columns={columns}
                pagination={pagination}
              />
            
          )}
        </CardBody>
      </Card>
    </>
  );
};
export default RakProfileCreateHistory;
